import { ShieldOff } from "lucide-react";
import { useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/app/providers/useAuth";
import { Button } from "@/shared/ui/button";

export function UnauthorizedPage() {
  const navigate = useNavigate();
  const { logout, displayName } = useAuth();

  const handleGoBack = () => {
    navigate({ to: "/auth/login", replace: true });
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch {
      // logout errors are already logged inside the hook
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-carbon-950 px-6 text-white">
      <div className="flex max-w-xl flex-col items-center gap-5 rounded-3xl border border-white/10 bg-white/5 px-10 py-12 text-center shadow-xl backdrop-blur">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-500/15 text-red-200">
          <ShieldOff className="h-8 w-8" aria-hidden />
        </div>
        <div className="space-y-2">
          <h1 className="text-3xl font-semibold">Access denied</h1>
          <p className="text-sm text-white/70">
            {displayName
              ? `${displayName} does not have an assigned app role for this application.`
              : "Your account does not have an assigned app role for this application."}
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Button size="lg" onClick={handleGoBack}>
            Step back
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="border-white/25 bg-white/10 text-white hover:bg-white/20"
            onClick={handleLogout}
          >
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
